import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from '../../../utils/media-query';
import { useCallback, useEffect, useRef, useState } from 'react';
import Form, { SimpleItem, Label, StringLengthRule, RequiredRule } from 'devextreme-react/form';
import 'devextreme-react/text-area';
import { useAppSelector } from '../../../contexts/hooks';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { SysINotasPlantillas, TypeNotasPlantillas } from '../../../types/types.config';
import { ResultEstadoResult } from '../../../types/types.orders';

interface ConfirmationPopupProps {
  visible: boolean;
  type: 'Validation' | 'Invalidation' | 'Tracking' | 'DeleteOrder';
  currentNote?: string;
  onConfirm: (note: string) => void;
  onCancel: () => void;
  state?: ResultEstadoResult;
}

const data = { note: '' };

export const ModalNotes: React.FC<ConfirmationPopupProps> = ({ visible, type, currentNote, onConfirm, onCancel, state }) => {
  const NotasPlantillas = useAppSelector((x) => x.configuration.Data?.NotasPlantillas);
  const [lstNotasPlantillas, setLstNotasPlantillas] = useState<SysINotasPlantillas[]>([]);
  const AllowCreateNoteInValidatedAnalitos: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AllowCreateNoteInValidatedAnalitos')[0].Cgn_Resultado) || 'false');
  const [title, setTitle] = useState<string>('');
  const { isXSmall, isSmall } = useScreenSize();
  const formRef = useRef<Form>(null);

  useEffect(() => {
    switch (type) {
      case 'Invalidation':
        setTitle('Nota de desvalidación');
        setLstNotasPlantillas(NotasPlantillas?.filter((x) => x.Pln_Tipo === TypeNotasPlantillas.Invalidation) || []);
        break;
      case 'Tracking':
        setTitle('Nota de tracking');
        setLstNotasPlantillas(NotasPlantillas?.filter((x) => x.Pln_Tipo === TypeNotasPlantillas.Tracking) || []);
        break;
      case 'Validation':
        setTitle('Nota de validación');
        setLstNotasPlantillas(NotasPlantillas?.filter((x) => x.Pln_Tipo === TypeNotasPlantillas.Validation) || []);
        formRef.current?.instance.updateData('template', null);
        formRef.current?.instance.updateData('note', currentNote);
        break;
      case 'DeleteOrder':
        setTitle('Nota de eliminación de orden');
        setLstNotasPlantillas(NotasPlantillas?.filter((x) => x.Pln_Tipo === TypeNotasPlantillas.EliminacionOrden) || []);
        break;
      default:
        break;
    }
  }, [visible]);

  const handleConfirm = useCallback(async () => {
    if (!formRef.current?.instance.validate().isValid) {
      return;
    }
    await onConfirm(data.note);
    formRef.current?.instance.updateData('note', '');
  }, [onConfirm]);

  const handleCancel = useCallback(async () => {
    onCancel();
  }, [onCancel]);

  const handleDataChange = useCallback((e: FieldDataChangedEvent) => {
    if (e.dataField === 'template' && e.value) {
      formRef.current?.instance.updateData('note', data.note + e.value + '\n');
      formRef.current?.instance.updateData('template', null);
    }
  }, []);

  return (
    <Popup height='auto' title={title} fullScreen={isXSmall || isSmall} onHidden={handleCancel} hideOnOutsideClick={true} width={500} visible={visible} dragEnabled={true} showTitle={true}>
      <ToolbarItem widget='dxButton' toolbar='bottom' location='after' options={{ text: 'CANCELAR', type: 'normal', onClick: handleCancel }} />
      <ToolbarItem widget='dxButton' toolbar='bottom' location='after' options={{ text: 'CONFIRMAR', stylingMode: 'contained', type: 'default', onClick: handleConfirm }} />
      <Form ref={formRef} formData={data} showValidationSummary={true} onFieldDataChanged={handleDataChange}>
        {lstNotasPlantillas?.length > 0 && (state && state >= ResultEstadoResult.Validado ? AllowCreateNoteInValidatedAnalitos : true) && (
          <SimpleItem dataField='template' editorType='dxSelectBox' editorOptions={{ items: lstNotasPlantillas, searchTimeout: 0, valueExpr: 'Pln_Notas', displayExpr: 'Pln_Abreviatura', searchEnabled: true }}>
            <Label text='Seleccione una plantilla' />
          </SimpleItem>
        )}
        <SimpleItem dataField='note' editorOptions={{ readOnly: (state && state >= ResultEstadoResult.Validado ? !AllowCreateNoteInValidatedAnalitos : false) || false, height: 100 }} editorType='dxTextArea'>
          {type !== 'Validation' && <RequiredRule message='El campo nota es requerido' />}
          <StringLengthRule min={type === 'Validation' ? 0 : 10} max={500} message='Por favor establezca una nota entre 10 y 500 caracteres' />
          <Label text='Ingrese una nota' />
        </SimpleItem>
      </Form>
    </Popup>
  );
};
